import { api } from ":mods";
import { CONST, model } from "..";
import { AResource } from "../../model";

export async function detailsPut(resource: number | string, data: model.PutResource) {
  return api
    .putAuth(CONST.ENDPOINTS.admin.detail_resource(resource), data)
    .then((res) => res.data.data.resources as AResource);
}
